<!--
   要贴别注意 HCB-197：iAP 无法混合（MIXIN）即补差的付款方式。因此 MIXIN 的付款方式在 ios 侧无法实现。
-->
<template>
    <div>
        <!-- 注意，这个 dialog 处理的相关逻辑是积分的支付逻辑 -->
        <my-dialog ref="dialog" title="购买" style="margin-top: 12vh;" :hide-callback="clearIntervals">
            <div style="padding-top: 4px">
                <!-- 1. way = points，表示积分足够，直接通过积分购买 -->
                <p v-if="paymentWay === PAYMENT_WAY.POINT">售 {{price}} 积分<span class="font-gray">（你当前拥有 <span class="font-black">{{totalPoints}}</span> 积分）</span></p>
                <!-- 2. way = cash 已经没有积分了，只能通过 CASH 购买-->
                <p v-else-if="paymentWay === PAYMENT_WAY.CASH">售价 ￥{{price}}</p>
                <!-- 3. way = mixin 拥有部分积分，CASH 和积分混用 -->
                <p v-else-if="paymentWay === PAYMENT_WAY.MIXIN">售 {{price}} 积分，你有 {{totalPoints}} 积分，需支付 ￥{{cashToPay}}</p>
                <p v-if="isLoggedIn">
                    <i class="el-icon-info">
                    <span style="padding-left:4px" class="font-gray">购买成功后，可额外获得 <span class="font-black">14</span> 天的下载有效期</span></i>
                </p>
            </div>
            <div class="margin-top-30px">
                <el-button v-if="paymentWay === PAYMENT_WAY.POINT" type="danger" round size="medium" @click="yap">积分支付</el-button>
                <!-- 苹果审核要求，如果不存在多选支付选项，则不应该单独出现苹果支付以及苹果 logo -->
                <!-- <el-button v-else-if="isNativeIosClient" round size="small" type="primary" icon="iconfont icon-sy-apple" style="font-size:14px" @click="yap">苹果支付</el-button> -->
                <el-button v-else-if="isNativeIosClient" round size="small" type="danger" style="font-size:14px" @click="yap">确认支付并下载</el-button>
                <el-button v-else type="success" round size="medium" @click="yap">微信支付</el-button>
                <!-- 匿名支付空间有点空荡荡的，填充下 -->
                <div class="margin-top-20px" v-if="!isLoggedIn">支付成功后将会自动开始下载！</div>
                <div class="margin-top-20px font-gray" align="center">Copyright &copy; 2021 <span class="font-gray">{{companyName}}</span></div>
            </div>
        </my-dialog>
        <!-- 打开 PC 端支付二维码窗口。备注：H5 页面的支付必须源站备案，绕不过，H5 就沿用 PC 端的支付方式，展示支付码的方式 -->
        <my-dialog ref="paymentDialog"
            title="请使用微信扫码支付"
            :content-style="{height: 325+'px'}"
            :dialog-width="isWebAgent? '30%': '100%' "
            :hide-callback="clearIntervals">
            <div>支付金额 ￥{{cashToPay}}</div>
            <div><img width="230" height="230" v-bind:src="paymentSvg" /></div>
            <div>支付成功后将会自动开始下载！</div>
            <div class="margin-top-20px font-gray" align="center">Copyright &copy; 2021 <span class="font-gray">{{companyName}}</span></div>
        </my-dialog>
    </div>
</template>

<script>
    import {
        errorMessage,
        successMessage,
        warningMessage,
        GlobalLoading,
        showLoginComponent,
        Styles,
        isH5PhoneAgent,
        isIosClient,
        isWebAgent,
        isHybridAgent,
        isNativeIosAgent,
        Constants,
        IapHelper
    } from "../../utils";
    import { getPaymentWay, createOrder, inquireOrder, confirmIapPayment } from "../../data/payment";
    import MyDialog from "./MyDialog";
    import { CachedApiSecurity } from "../../api-security";
    import assert from 'assert';

    export default {
        name: "Payment",
        components: { MyDialog },
        props: {
            shortcode: null
        },
        data(){
            return {
                totalPoints: null,
                price: null, // the entity's price loaded from backend.
                // constants
                PAYMENT_WAY: {
                    POINT: 'point',
                    CASH: 'cash',
                    MIXIN: 'mixin'
                },
                paymentWay: null, // fetch from backend server
                tradeId: null, // 交易号，用来轮询交易转台的
                paymentSvg: null,
            }
        },
        computed: {
            cashToPay(){
                return this.price - this.totalPoints;
            },
            isH5Agent(){
                return isH5PhoneAgent();
            },
            isWebAgent(){
                return isWebAgent();
            },
            isHybridAgent(){
                return isHybridAgent();
            },
            isIosClient(){
                return isIosClient();
            },
            isNativeIosClient(){
                return isNativeIosAgent();
            },
            isLoggedIn(){
                return CachedApiSecurity.isSignedIn();
            },
            companyName() {
                return this.$store.state.displayCtrl === null ? "酷凡网络" : this.$store.state.displayCtrl.companyName
            }
        },
        mounted() {
            console.log('Payment mounted');
            // 初始化 channel 的流程已经放到 Header.vue 的 mounted 中了，因为 channel 只需要被初始化一次
            // if (this.isHybridAgent){
            //     // 获取支付通道，现在只有微信，因此直接返回数组中的第一个即可。
            //     // id： "alipay" - 表示支付宝； "wxpay" - 表示微信支付； "appleiap" - 表示苹果应用内支付； "qhpay" - 表示360聚合支付（仅360手助流应用环境下支持）。
            //     // updated in-app purchased payment for iOS
            //     // 如果是 iOS 端必须使用苹果内购，相反如果是 Android 端则使用微信支付。
            //     var target = this.isIosClient ? 'appleiap': 'wxpay';
            //     plus.payment.getChannels((channels) => {
            //         for(var i in channels){
            //             var channel = channels[i];
            //             console.log(`=========> channel id: ${channel.id}`);
            //             if(channel.id === target){
            //                 this.channel = channel;
            //                 break;
            //             }
            //         }
            //         console.log('the payment channle is ', JSON.stringify(this.channel));
            //         if (this.channel === undefined || this.channel === null)
            //             throw Error('payment channel is not determined');
            //
            //         if (this.isIosClient)
            //             (async()=>{
            //                 await IapHelper.initIap(this.channel);
            //             })();
            //     }, function(e) {
            //         console.error("获取支付通道失败：" + e.message);
            //     });
            // }
        },
        beforeDestroy() {
            console.log('payment destroy')
            // 销毁 interval 如果存在的话
            this.clearIntervals();
            // document.removeEventListener('resume');
        },
        methods: {
            /**
             * 开启支付流程，检测支付类型，如果积分够则直接返回积分支付类型并开启积分支付流程，如果不够，则直接 Cash 支付流程。
             */
            start(){
                (async()=>{
                    if ( !CachedApiSecurity.isSignedIn() ){ // 未登录，提示登录
                        this.$confirm('系统检测到你没有登录，是否登录后购买？', '提示', {
                            distinguishCancelAndClose: true,
                            confirmButtonText: '确定',
                            confirmButtonClass: 'el-button--danger',
                            cancelButtonText: '不，我要直接购买',
                            cancelButtonClass: 'el-button--default',
                            type: 'info'
                        }).then(() => { // 这是确定分支
                            showLoginComponent(); // 显示登录窗口
                        }).catch((action) => { // 这是取消分支
                            (async()=>{
                                if (action === 'cancel'){ // 表示用户点击了页面上的 cancel button，即是要匿名支付
                                    await this.showPaymentInfo();
                                } else { // 这是用户直接点击了关闭按钮，do nothing.
                                    console.log('user close the payment confirm window');
                                }
                            })();
                        })
                    }else{ // 已登录用户
                        GlobalLoading.start();
                        // 获取支付类型
                        try {
                            await this.showPaymentInfo();
                        }catch(error){
                            console.error(error);
                        }finally {
                            GlobalLoading.stop();
                        }
                    }
                })();
            },

            // 目前这个方法仅被 triggerDownload 调用。
            hide(){
                this.$refs.dialog.hide();
                this.clearIntervals();
            },

            async showPaymentInfo(){
                let r = await getPaymentWay(this.shortcode);
                console.log(`payment, payment way is ${r.way}`);
                this.totalPoints = r.points; // 该用户当前的积分总数，用于展示
                this.price = r.price;
                this.paymentWay = r.way;
                this.$refs.dialog.show();
            },

            /**
             * 支付窗口中，用户点击支付后的回调方法
             * 1. 如果支付方式是 point 即积分完全够用，那么直接生成订单，并开始下载
             * 2. 如果支付方式是 MIXIN 即积分部分够用，需要部分 CASH 支付，则请求后台生成微信支付二维码，并展示。
             * 3. 如果支付方式是 CASH 即全部 CASH 支付，则请求后台生成微信支付二维码，并展示。
             * 注意：
             * 1. 这里是轮询支付状态来检测是否支付成功的
             * 2. 一旦支付成功后，发送 ispaied event 给 download 组件，告诉它是否支付成功，若成功的话，开启下载。
             *
             * HCF-434: 苹果审核会检查源码中的关键字，最好不要带 pay，全部改成 yap
             *
             */
            async yap(){
                try {
                    if (this.paymentWay === this.PAYMENT_WAY.POINT){ // 如果采用积分支付
                        await this.__pointYap();
                    } else { // 如果适用其它支付类型，目前由 CASH 和 MIXIN
                        if (this.isHybridAgent && this.isIosClient ){ // native iOS app 的支付模式
                            await this.__iapPay(this.price);
                        } else if (this.isHybridAgent) { // 其他 native app 的支付模式 -> 这里可以统一的视为 Android 的支付方式了
                            await this.__wcYap();
                        } else { // Web 的支付模式
                            await this.__webYap();
                        }
                    }
                } catch(error){
                    console.error(error);
                    throw error;
                }
            },

            /* ========= Point payment START ========= */
            async __pointYap(){
                GlobalLoading.start();
                try {
                    // 使用积分支付，后台会验签（验证前端指定的 PAYMENT_WAY 是否合法）
                    let r = await createOrder(this.shortcode, this.paymentWay);
                    successMessage('支付成功');
                    setTimeout(() => {
                        this.triggerDownload(r.deal);
                        GlobalLoading.stop();
                    }, 300);
                } catch(error){
                    console.error(error);
                    GlobalLoading.stop();
                    throw error;
                }
            },
            /* ========= Point payment END ========= */

            /* ========= Web payment START ========= */
            /**
             * H5 或者是 Web payment
             */
            async __webYap(){
                console.log('this is the web payment');
                try {
                    GlobalLoading.start();
                    let r = await createOrder(this.shortcode, this.paymentWay);
                    this.paymentSvg = r.svg;
                    this.tradeId = r.tradeId;
                    setTimeout(() => {
                        this.$refs.paymentDialog.show(); // 显示付款二维码
                        GlobalLoading.stop();  // 只要二维码一展示，必须停止 loading..
                        this.inqueryPaymentStatus(); // 只要打开二维码的窗口，则开始询问，但记得，如果用户关闭了二维码支付窗口则停止 inquire
                    }, 300);
                } catch(error){
                    console.error(error);
                    GlobalLoading.stop();
                    throw error;
                }
            },
            /* ========= Web payment END ========= */


            /* ========= Other native app START - 除了 ios 以外的 native app ======== */

            /**
             * 除了 iOS 以外的其他的 native payment 目前都是用微信支付接口。
             * HCF434: 苹果审核比较严格，不能出现 wechat 或者 alipay 等关键字，将其改为 wc
             */
            async __wcYap(){
                GlobalLoading.start();
                try {
                    let r = await createOrder(this.shortcode, this.paymentWay);
                    let channel = this.$store.state.channel;
                    assert.ok(channel !== null);
                    let params = r.params; // 发起微信支付需要的 params
                    this.tradeId = r.tradeId;
                    console.log(`tradeId: ${this.tradeId}, params: ${JSON.stringify(params)}`);
                    // plus.nativeUI.alert(`params: ${JSON.stringify(params)}`);
                    // 2. 发起支付请求
                    // BUG，现在支付成功后 iOS 并不会回调 success callback，无奈还是只能采用轮询。据说 Android 没有这样的问题，但都统一成轮询的实现方式。
                    plus.payment.request(channel, params, (result) => {  // 支付成功回调
                        // FIXME: why it is not get callback in iOS?
                        console.log('invoke wechat success');
                        // successMessage('支付成功!');
                        // plus.nativeUI.alert('支付成功！');
                        // this.inqueryPaymentStatus();
                        GlobalLoading.stop();
                    }, (error) => { // 支付失败回调
                        console.error(JSON.stringify(error));
                        plus.nativeUI.alert("支付失败，请稍后重试！");
                        setTimeout(() => {
                            this.clearIntervals();
                        }, 300); // 给 300 毫秒的延迟确保 interval 已经创建成功。
                        GlobalLoading.stop();
                    });
                    // BUG，现在支付成功后 iOS 并不会回调 success callback，无奈还是只能采用轮询
                    // TODO 但是现在苹果不能使用微信支付，因此这个轮询在 Android 是否显得不重要了？
                    this.inqueryPaymentStatus();
                } catch(error){
                    console.error(error);
                    GlobalLoading.stop();
                    throw error;
                }
            },
            /* ========= Other native app END - 除了 ios 以外的 native app ======== */

            /* ========= IAP START ========= */

            /**
             * 苹果的定价是由苹果的 iAP 的 productId 决定的，productId 中对应了苹果指定的金额。因此现在要做的是，将 huocool 的金额
             * 映射到 iAP 的 productId 上，以便发起支付。目前最直接的想法是，使用金额对应 ￥3 <-> HC_0003，￥6 <-> HC_0006
             * 但是这样左右一个弊端，就是如果价格改动了，则无法映射到正确的 Iap productId 了，也就无法发起支付了 -> 如果无法发起支付，则默认 HC_0003
             * @return iAP productId
             */
            getIapProductIds(price){
                if( price === 3 )
                    return 'HC_0003';
                else if (price === 6)
                    return 'HC_0006';
                else {
                    return 'HC_0003';
                }
            },

            /**
             * https://ask.dcloud.net.cn/article/497
             * 注意里面丢单问题
             */
            __iapPay(price){
                console.log('start iap payment');
                GlobalLoading.start();
                let channel = this.$store.state.channel;
                if (channel === null) {
                    GlobalLoading.stop();  // 生产环境上（真机环境上）不会出现这个 BUG：当 Channel 不存在，Global Loading 不停止。
                    throw Error('the channel should not be null during iap payment')
                }
                // =========== request Order 初始化完毕后，下面开始发起 iap 支付。===========
                var iapProductId = this.getIapProductIds(price);
                console.log(`the iap product id get as ${iapProductId} by price ${price}`);
                // 正式发起支付调用 Apple Pay
                // restoreFlag 标记，用于判断在页面显示的时候是否需要调用 restoreComplateRequest 方法
                // var restoreFlag = true; // 调用支付接口时标记 restoreFlag = true , 实际应用请将标记存储在 storage 中
                window.localStorage.setItem(Constants.iAPRestoreFlag, true); // 这个标志位实际上表示开始了一个支付的过程，注意，巨坑... 存储的类型是 String...
                // window.localStorage.setItem(Constants.iAPShortcode, this.shortcode);
                // window.localStorage.setItem(Constants.iAPPrice, this.price);
                // params 在支付成功后会回调
                // - shortcode 和 price 必须通过 feedback 传递，否则无法兼容 app crash 丢单的问题，见 HCB-198
                // - 经过测试，发现 plus.payment.request 用户不能自定义参数，即便是自定义了，也不会返回，比如之前自定义的 shortcode 就被 ignored 了
                // - 因此，为了传递 shortcode 和 price，目前的做法是，通过 username 来传递了。
                var params = {
                    productid: iapProductId,
                    username: JSON.stringify({shortcode: this.shortcode, price: this.price}),   // 只能用它来作为 attach 字段，详情参看上面的 comments
                    // shortcode: this.shortcode, // 这个参数"误删"；记录不能自定义参数，支付成功后，app store 并不会返回自定义的参数。
                    // quantity: 1, // 不用填写，默认为 1
                    optimize: true  // 设置 optimize: true 解决丢单问题
                }
                console.log('start the request the iap, the params:', JSON.stringify(params));
                plus.payment.request(
                    channel,
                    params,
                    function(feedback) { // 成功回调
                        (async()=>{
                            console.log(`plus.payment.request iap payment success callback with feedback, ${JSON.stringify(feedback, null, 4)}`);
                            try {
                                console.log(`iap feedback, attach: ${feedback.paymentusername}`);
                                let attach = JSON.parse(feedback.payment.username); // attachment, 注意传递的 attach 参数是在返回的 payment 节点下。
                                let r = await IapHelper.iAPConfirm(feedback, attach.shortcode, attach.price);
                                // 注意，后台无需返回是否支付成功的标志位给前端，因此在 trigger download 的时候会检查是否支付成功。
                                plus.nativeUI.alert('支付成功！', () => {
                                    setTimeout(() => {
                                        GlobalLoading.stop();
                                        /*
                                         * 下面这个 if 分支不想删除
                                         * 这是 app crash 丢单后恢复的情况，因为是之前订单的 shortcode，因此这里不能发起下载
                                         * 实际上这种情况并不会发生，这里的 feedback 还是刚刚传递的，并不是上一次的 feedback。看来 AppStore
                                         * 只是根据 iAP product id 来区分是否是同一个订单。因此，下面的这个 if 分支并不会执行。
                                         */
                                        if (attach.shortcode !== this.shortcode) {
                                            plus.nativeUI.alert('之前的订单已经完成，请进入下载列表查看');
                                            this.hide();
                                        } else { // 正常流程，发起下载动作
                                            this.triggerDownload(r.deal); // 方法内部会调用 hide
                                        }
                                    }, 300)
                                });
                            } catch(error) {
                                GlobalLoading.stop();
                                console.error(error);
                            }
                        })();
                    }.bind(this),
                    function(e) { // 失败回调
                        GlobalLoading.stop();
                        console.log('plus.payment.request iap payment callback failed, the error is ', JSON.stringify(e));
                        // 支付失败的时候需要调用一下 restoreComplateRequest 方法
                        IapHelper.restoreCompletionRequest();
                    }.bind(this)
                );
            },

            /* ========= IAP END ========= */

            /**
             * 本来 inqure payment status 方法只是提供给 web 端使用的，无奈，ios 支付成功后并不会触发回调
             */
            inqueryPaymentStatus(){
                this.interval = setInterval(()=>{
                    (async() => {
                        console.log('check the payment status with trade id:', this.tradeId);
                        let r = await inquireOrder(this.tradeId);
                        if (r.paid){
                            console.log('inquery payment status, detected paid, the interval obj', this.interval);
                            // clearInterval(this.interval);
                            this.clearIntervals();
                            if (this.isHybridAgent){ // app 端回调
                                plus.nativeUI.alert('支付成功！', () => {
                                    setTimeout(()=>{
                                        this.triggerDownload(r.deal);
                                        // this.$refs.paymentDialog.hide();
                                    }, 300)
                                });
                            } else { // web 端回调
                                successMessage('支付成功');
                                setTimeout(() => {
                                    this.triggerDownload(r.deal);
                                    this.$refs.paymentDialog.hide();
                                }, 300)
                            }
                        }
                    })();
                }, 800);
            },

            triggerDownload(deal){
                this.$emit('ispaid', true); // true -> success
                this.$EventBus.$emit('bought', deal); // HCF413 - repaint the bought entity in user center deal page.
                setTimeout(()=>{
                    this.hide();
                }, 300)
            },

            clearIntervals(){
                if (this.interval !== undefined && this.interval !== null){
                    // 注意，一定要使用 window. 前缀，否则在 Android 机上会出现问题，interval 不能被清除。
                    window.clearInterval(this.interval);
                    console.log('the interval get cleared');
                }
            }
        }
    }
</script>

<style scoped>
    /* mobile screen */
    @media (max-width: 735px) {
        /deep/ .dialog-content-panel {
            height: 205px;
        }
    }

    /* pc screen */
    @media (min-width: 736px) {
        /deep/ .dialog-content-panel {
            height: 200px;  /* 注意，不能设置为 important，否则二维码支付弹窗 paymentDialog 无法通过 :content-style 自定义高度 */
        }
    }

    .el-button.is-round{
        padding: 12px 40px; /* 将微信的按钮拉长 */
    }

    /deep/ .icon-sy-apple {
        margin-right: 8px;
    }

</style>



// WEBPACK FOOTER //
// src/components/commons/Payment.vue